// store.js
import { configureStore } from "@reduxjs/toolkit"; // modern Redux approach
import thunk from "redux-thunk";
import homeReducer from "./homeReducer";
import productReducer from "./slices/productSlice";

// Create the store
const store = configureStore({
  reducer: {
    home: homeReducer, // add other reducers here if needed
    product: productReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // add thunk middleware
  devTools: process.env.NODE_ENV !== "production", // enable Redux DevTools only in dev
});

export default store;
